module.exports = __webpack_public_path__ + "img/leftbicep-ecto-mesomorph-male.9ae1ac15.svg";